import { useGenomeViewerStore } from "../../../store/store.ts";
import { getGroupPosition } from "../utils/group-position.ts";

export function useGroupPosition(scale: number, groupHeight: number) {
  const trackGroups = useGenomeViewerStore((state) => state.trackGroups);
  const basePerPixel = useGenomeViewerStore((state) => state.basePerPixel);
  const getOriginOffset = useGenomeViewerStore((state) => state.getOriginOffset);

  // Translates the relative coordinate system to the absolute coordinate system starting at 0
  const originOffset = -getOriginOffset();

  const groupPosition = [...trackGroups]
    .filter(([, trackGroup]) => trackGroup.graphics.isVisible)
    .map(([groupId, trackGroup], idx) => {
      const { x, y } = getGroupPosition(
        idx,
        scale,
        trackGroup.graphics.baseShift,
        basePerPixel,
        groupHeight,
        originOffset,
      );

      return { x, y, groupId };
    });

  return groupPosition;
}
